import(/* webpackMode: "eager", webpackExports: ["AnnouncementsPageContent"] */ "/vercel/path0/src/components/inbound-gpt/resources-pages.tsx");
